import React, { Component } from 'react';
import ActionButton from '../../common/ActionButton';
import { getErrorMessages } from '../../../utils';
import { ErrorMessage } from '../../common';
import { executeHttpRequest } from '../../../epics/api';
import LoadingSpinner from '../../common/LoadingSpinner';
import { TPageNotification } from '../../../types';

type RenameAvailabilityListProps = {
    currentUrlParams: URLSearchParams;
    notification: TPageNotification;
    onActionSuccess: () => void;
    closeModal: () => void;
    reloadData: () => void;
    availabilityLists: { label: string, value: string | number }[];
}

type RenameAvailabilityListState = {
    isLoading: boolean;
    newName: string;
    error: string;
    selectedList: number;
}

export class RenameAvailabilityList extends Component<
    RenameAvailabilityListProps,
    RenameAvailabilityListState
> {
    constructor(props: RenameAvailabilityListProps) {
        super(props);

        const _selectedList = props.currentUrlParams.get('availability_lists');
        this.state = {
            isLoading: false,
            error: null,
            newName: '',
            selectedList: _selectedList ? Number(_selectedList) : null,
        };
    }

    getListName = (id: number) => {
        const matchedList = this.props.availabilityLists.find(item => item.value === id);
        return matchedList ? matchedList.label : null;
    }

    updateAvailabilityList = ()=> {
        this.setState({ isLoading: true });
        const payload = {
            name: this.state.newName,
        };

        executeHttpRequest(
            `availability-lists/${this.state.selectedList}/`,
            'patch',
            payload,
        ).then(response => {
            this.setState({ isLoading: false });
            const currentListName = this.getListName(this.state.selectedList);
            const newListName = response.data.content.name;
            const successMessage = `"${currentListName}" has been successfully renamed to "${newListName}".`;
                this.props.notification.success('Success', successMessage);
                this.props.closeModal();
                // this.props.reloadData();
                if (this.props.onActionSuccess) {
                    this.props.onActionSuccess();
                }
        }).catch(error => {
            this.setState({
                error: getErrorMessages(error),
                isLoading: false,
            });
        });
        };

    handleNameTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({ newName: event.target.value });
    }


    render() {
        const listName = this.getListName(this.state.selectedList);

        return (
            <div className="cancel-shift">
                <div className="popup-header">
                    <h1>
                        Rename Availability List
                    </h1>
                </div>
                <div>
                    Please enter a new name for <q><strong>{listName}</strong></q>:
                </div>
                <div style={{ paddingTop: '10px' }}>
                    <textarea
                        name="new_list_name"
                        onChange={this.handleNameTextChange}
                        placeholder="Name..."
                        maxLength={30}
                        rows={1}
                    />
                </div>
                <div className="modal-bottom-bar">
                    <ActionButton
                        onAction={this.updateAvailabilityList}
                        text={this.state.isLoading
                            ? (
                                <LoadingSpinner
                                    className="mass-booking-spinner"
                                    backgroundColor="white"
                                />
                            ) : (
                                'CONFIRM'
                            )
                        }
                        className="confirm"
                    />
                    <ActionButton
                        onAction={this.props.closeModal}
                        text="Cancel"
                        className="cancel"
                    />
                </div>
                {this.state.error ? (
                    <ErrorMessage message={this.state.error} />
                ) : false}
            </div>
        );
    }
}
